//对axios进行二次封装,将刚才下载好的axios导入进来
import axios from 'axios';
import { getToken, removeToken, removeCookies, getTenant } from './token';
import { ElMessageBox, ElMessage } from 'element-plus';
import { useRouter } from 'vue-router';
import { loginOut } from '@/request/system';

//2. 利用axios对象的方法create,去创建一个axios实例
//requests就是axios,只不过稍微配置一下
const api = axios.create({
    //基础路径
    // withCredentials: true,
    baseURL: process.env.VUE_APP_BASEURL, // 所有请求的公共地址部分
    timeout: 30000 // 请求超时时间,这里的意思是当请求时间超过5秒还未取得结果时,提示用户请求超时
});

// api.defaults.withCredentials = true;
// 请求拦截处理 请求拦截 在请求拦截中可以补充请求相关的配置
// interceptors axios的拦截器对象
api.interceptors.request.use(
    config => {
        // config 请求的所有信息
        const isToken = (config.headers || {}).isToken;

        config.headers['Tenant'] = getTenant();
        // console.log(config);
        if (!isToken && getToken()) {
            config.headers['Authorization'] = getToken(); // 让每个请求携带自定义token 请根据实际情况自行修改
        }
        // 响应成功的返回
        return config; // 将配置完成的config对象返回出去 如果不返回 请求讲不会进行
    },
    err => {
        // 请求发生错误时的相关处理 抛出错误
        //  //响应失败的返回
        Promise.reject(err);
    }
);

//响应拦截处理  响应拦截器：包含两个函数（一个是成功返回的函数，一个是失败的返回的函数）
api.interceptors.response.use(
    res => {
        // 我们一般在这里处理，请求成功后的错误状态码 例如状态码是500，404，403
        // res 是所有相应的信息
        const { code, msg } = res.data;
        if (code == 400 || code == 500 || code == 601 || code == 602) {
            ElMessage({
                showClose: true,
                message: msg,
                type: 'error'
            });
        }
        if (code == 401) {
            ElMessageBox.confirm('登录状态已过期，您可以继续留在该页面，或者重新登录', '系统提示', {
                confirmButtonText: '重新登录',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    removeToken();
                    removeCookies('tagRoutes');
                    removeCookies('tagViews');
                    location.href = '/';
                })
                .catch(() => {});
        }
        if (code == 200) {
            return res.data;
        }
    },
    err => {
        if (err.response) {
            const status = err.response?.status;
            if (status == 401) {
                ElMessageBox.confirm('登录状态已过期，您可以继续留在该页面，或者重新登录', '系统提示', {
                    confirmButtonText: '重新登录',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
                    .then(() => {
                        removeToken();
                        removeCookies('tagRoutes');
                        removeCookies('tagViews');
                        location.href = '/';
                    })
                    .catch(() => {});
            } else {
                ElMessage.error(err.response.data.msg);
            }
            // if (status == 404) {
            //     ElMessage.error(err.response.statusText);
            // }
        } else {
            ElMessage.error(err.message);
        }

        // 服务器响应发生错误时的处理
        //Promise.reject(err)
    }
);

export default api;
